import React, { useState } from 'react';
import { trackFeatureUsage } from '@animoto/utils/analytics';
import {
  Button,
  HeaderExtraSmall,
  Overlay,
  overlayTypes,
  ToastPanel,
  toastPanelAlignments
} from '@animoto/components/lib/es/design-system';
import './OwnerToast.module.css';

export default function OwnerToast() {
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);
  const onClickButton = () => {
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'owner-share-toast',
      action  : 'click:share-page'
    });
  };
  const onOverlayClick = () => {
    setIsOverlayVisible(false);
    trackFeatureUsage({
      scope   : 'visitor-play-page',
      feature : 'owner-share-toast',
      action  : 'click:dismiss-overlay'
    });
  };
  return (
    <>
      <ToastPanel
        alignment={toastPanelAlignments.RIGHT}
        isDismissable={false}
        isOpen
      >
        <div styleName="content">
          <HeaderExtraSmall styleName="text">This is the video page your viewers will see.</HeaderExtraSmall>
          <Button
            className="s-toast-button"
            href={`/share/${window.location.href.split('/').pop()}`}
            onClick={onClickButton}
            styleName="button"
          >
            Share video
          </Button>
        </div>
      </ToastPanel>
      {isOverlayVisible && (
        <div
          aria-label="Overlay"
          className="s-overlay-wrap"
          onClick={onOverlayClick}
          role="button"
          tabIndex={0}
        >
          <Overlay styleName="overlay" type={overlayTypes.DARK} />
        </div>
      )}
    </>
  );
}
